export default __webpack_public_path__ + "baa1cc27aedc334404f8d96060a8cfa8.webp";